import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight, Plus, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { EmptyState, ErrorState, LoadingState, PageHeader, StatusBadge } from "@/components/common/States";
import { fetcher } from "@/lib/api";
import { TENANT_STATUS } from "@/lib/labels";

export default function MitraPelanggan() {
  const q = useQuery({ queryKey: ["mitra", "pelanggan"], queryFn: () => fetcher("/reseller/pelanggan") });

  return (
    <div className="space-y-6">
      <PageHeader eyebrow="Ruang Mitra SIST" title="Kelola Pelanggan"
        description="Sekolah binaan yang ditugaskan Pusat Kendali kepada Anda. Lengkapi kontak sekolah dan pantau anggotanya; data anggota hanya bisa dilihat, tidak diubah dari sini."
        actions={
          <Button asChild data-testid="mitra-pelanggan-daftar-button">
            <Link to="/mitra/daftar"><Plus className="h-4 w-4 mr-1.5" /> Daftarkan Sekolah</Link>
          </Button>
        } />

      {q.isLoading && <LoadingState rows={4} />}
      {q.error && <ErrorState error={q.error} onRetry={q.refetch} />}
      {q.data && (
        q.data.items.length === 0 ? (
          <div className="rounded-2xl border bg-card p-6" data-testid="mitra-pelanggan-empty">
            <EmptyState title="Belum ada sekolah binaan"
              description="Sekolah masuk daftar ini setelah Pusat Kendali menerima pengajuan dan menugaskannya kepada Anda. Anda juga bisa mengajukan sekolah lewat tombol Daftarkan Sekolah." />
            <div className="flex justify-center">
              <Button asChild variant="outline" data-testid="mitra-pelanggan-empty-cta">
                <Link to="/mitra/daftar">Ajukan sekolah pertama <ArrowRight className="h-4 w-4 ml-1.5" /></Link>
              </Button>
            </div>
          </div>
        ) : (
          <ul className="grid md:grid-cols-2 gap-4" data-testid="mitra-pelanggan-list">
            {q.data.items.map((s) => (
              <li key={s.id}>
                <Link to={`/mitra/pelanggan/${s.id}`}
                  className="block rounded-2xl border bg-card p-5 hover:border-foreground/20 transition-colors"
                  data-testid={`mitra-pelanggan-card-${s.id}`}>
                  <div className="flex items-start justify-between gap-3">
                    <div className="min-w-0">
                      <p className="font-semibold truncate">{s.name}</p>
                      <p className="text-sm text-muted-foreground">{[s.city, s.level].filter(Boolean).join(" · ") || "—"}</p>
                    </div>
                    <StatusBadge map={TENANT_STATUS} value={s.status} />
                  </div>
                  <div className="mt-3 flex items-center gap-1.5 text-sm text-muted-foreground" data-testid={`mitra-pelanggan-anggota-${s.id}`}>
                    <Users className="h-4 w-4" aria-hidden /> {s.anggota} anggota
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        )
      )}
    </div>
  );
}
